import { createContext } from 'react';
import type { ResolvedTheme, ThemeMode } from './theme.type.ts';

export interface ThemeContextValue {
  /** 사용자가 선택한 모드 (light | dark | system) */
  mode: ThemeMode;
  /** 실제 적용된 테마 (light | dark) */
  resolvedTheme: ResolvedTheme;
  /** 모드를 명시적으로 설정 */
  setMode: (mode: ThemeMode) => void;
  /** light ↔ dark 토글 (현재 적용된 테마 기준) */
  toggle: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
